import type { MetaFunction } from '@remix-run/node';

import { getCanonicalURL } from '~/utils/getCanonicalURL';

import type { loader } from './loader';

export const meta: MetaFunction<
	never,
	{ [routeId: string]: typeof loader }
> = ({ location, matches }) => {
	const data = matches.find(match => /subevent-sports$/.test(match.id))?.data;

	const displayName = data?.mapping.displayName;

	return [
		{
			title: `${
				displayName ? `${displayName} ` : ''
			}Betting Odds | OddsChecker`,
		},
		{
			name: 'description',
			content: `Get the best available ${
				displayName ? `${displayName} ` : ''
			}odds from all online bookmakers with OddsChecker, the home of betting value.`,
		},
		...(data?.componentStyles || []).map((href, index) => ({
			key: `componentStyles-${index}`,
			tagName: 'link',
			rel: 'stylesheet',
			href,
		})),
		{
			tagName: 'link',
			rel: 'canonical',
			href: getCanonicalURL(data?.url, location.pathname),
		},
		...(data?.hreflangs || []).map(({ href, hreflang }, index) => ({
			key: `hreflang-${index}`,
			tagName: 'link',
			rel: 'alternate',
			href,
			hrefLang: hreflang,
		})),
		// NOTE: v2_meta seems to be broken at the moment with ld+json so
		// we have generated the script element ourselves in the route.tsx...
		// Would be good to get this back here in `meta.ts` at some point
		// {
		//   "script:ld+json": {
		//     "@context": "https://schema.org",
		//     "@type": "SportsEvent",
		//     name: data?.mapping.preMatch.displayName,
		//     url: data?.url,
		//     startDate: data?.mapping.preMatch.startDate,
		//     location: {
		//       "@type": "Place",
		//       name: data?.cardMapping.cardTitle,
		//       address: {
		//         "@type": "PostalAddress",
		//         name: "",
		//       },
		//     },
		//   },
		// },
	];
};
